import { observable, configure, action, computed, toJS } from 'mobx';
import StoreModel from './storeModel';
import util from '../lib/util';

configure({ enforceActions: 'always' });

class ArticleStore extends StoreModel {
    constructor() {
        super('article', {
            namePlural: 'articles',
            sort: 'sort,-publishDate,-create_date',
            api: {
                search: {
                    url: '/api/articles/',
                    params: {
                        extendedView: 1,
                        showall: 1,
                        limit: 15,
                        sort: 'id',
                    },
                },
                load: {
                    url: '/api/articles/',
                    params: {
                        showall: 1,
                    },
                },
                save: {
                    url: '/api/articles/',
                    params: {},
                },
            },
        });
    }

    @observable article = {};

    @observable articles = [];

    @observable tagList = [];

    @observable tagIdRef = {};

    makeQuery() {
        const query = toJS(this.queryFilter);
        if (query.search) {
            delete query.tag;
        }
        return query;
    }

    @action
    addImage(id, imageObject) {
        const article = this.article.id ? this.article : this.article.find(e => e.id === id);
        if (typeof article === 'object') {
            let maxNum = 0;
            if (typeof article.imgs === 'object') {
                const imgKeys = Object.keys(article.imgs);
                for (let i = 0, l = imgKeys.length; i < l; i += 1) {
                    const key = parseInt(imgKeys[i], 10);
                    if (key > maxNum) {
                        maxNum = key;
                    }
                }
            } else {
                article.imgs = {};
            }
            const nextNum = maxNum + 1;
            const newImage = {
                ...imageObject,
                sort: nextNum,
            };
            article.imgs[nextNum] = newImage;
            this.saveField(id, 'imgs', article.imgs, true);
        }
    }

    @action
    delImage(id, imageId) {
        const article = this.article.id ? this.article : this.article.find(e => e.id === id);
        if (typeof article === 'object' && typeof article.imgs === 'object') {
            delete article.imgs[imageId];
            const imageArray = util.makeArrayOfObject(article.imgs);
            article.imgs = util.makeObjectOfArray(imageArray);
            this.saveField(id, 'imgs', article.imgs, true);
        }
    }
}

const store = new ArticleStore();
export default store;



// WEBPACK FOOTER //
// ./stores/article.js